import axios, { AxiosError } from 'axios';
import { auth } from '../firebase'; // your firebase.ts file


interface OrderPayload {
  businessId: number;
  customerEmail: string;
  name: string;
  country: string;
  region: string;
  city: string;
  address: string;
  number: string;
  items: {
    productId: number;
    quantity: number;
  }[];
}

export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

export const create_order = async (orderPayload: OrderPayload) => {
  try {
    const response = await backendAPI.post(
      'orders/create',
      {
        ...orderPayload
      }
    );

    return response.data;

  } catch (error) {
    console.error("Error creating order and payment:", error);
    throw error;
  }
};

export const get_all_orders = async (userBusinessId: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");

    const idToken = await user.getIdToken();
    
    const response = await backendAPI.get(`orders/business/${userBusinessId}`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching process logs:", error);
    throw error;
  }
};

export const get_order_items = async (orderId: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");

    const idToken = await user.getIdToken();
    
    const response = await backendAPI.get(`orders/orderitems/${orderId}`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching process logs:", error);
    throw error;
  }
};

export const get_order_status = async (orderId: number, businessId: number) => {
  try {
    const response = await backendAPI.get(`orders/status/${orderId}`, {
      params: { businessId },
    });
    return response.data as {
      orderId: number;
      status: string;
      total: number;
      customerEmail: string;
      isPaid: boolean;
      createdAt: string;
      updatedAt: string;
    };
  } catch (error) {
    console.error('Error fetching order status:', error);
    throw error;
  }
};

export const refund_order = async (orderId: number, amount?: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error('User not logged in');

    const idToken = await user.getIdToken();
    const response = await backendAPI.post(
      `orders/${orderId}/refund`,
      amount ? { amount } : {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error refunding order:', error);
    throw error;
  }
};